import React, {useState, useEffect} from "react";
import {useHistory, useParams} from "react-router-dom";
import moment from "moment";

import GenericTemplate from "../../templates/GenericTemplate";
import {
  apollo_useStyles,
  options_platformdetail_path,
  valueToOption,
} from "../../atom/Apollo_styles";
import {
  APOLLO_GROUP_OPERATOR,
  ApolloUserProfileAuth,
  APOLLO_PROFILE_SYSTEM_OPERATOR,
} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import {
  budgets_path,
  apollo_budget_path,
  apollo_budgetno_master_path,
  apollo_budget_cost_performances_path,
} from "../../atom/Apollo_links";
import {ApolloDataTable} from "../../atom/Apollo_DataTable";
import {CustomizedSnackbars} from "../../atom/Apollo_Mesasge"
import {
  AccountBudget,
  AmountMessage,
  AccountBudgetCostPerformances,
} from "./BudgetModel";
import {BudgetnoMaster} from "../../organism/MASTER/Apollo_MasterModel";
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {optionsZeusDeliveryType} from "../../common/Apollo_CommonConst";
// メッセージ定義
import {
  GetMessage,
  UI_BUDGET_DETAIL,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import Card from "@material-ui/core/Card/Card";
import CardActions from "@material-ui/core/CardActions";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles";

// テーブル表示データ定義
type tableDataType = {
  budgetno: number,
  budgetName: string,
  cost: number,
  platformBudget1Amount: number,
  platformBudget2Amount: number,
}

/*
    画面名：予算管理 広告主アカウント詳細画面
 */
const BudgetDetail: React.FC = () => {
  // 0: 新規　、　id：編集
  const {accountid} = useParams<{accountid: string}>();
  const {yearMonth} = useParams<{yearMonth: string}>();

  const history = useHistory();
  const classes = apollo_useStyles();
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {state, dispatch} = React.useContext(ApolloContext);

  const [row, setRow] = useState<AccountBudget>();
  const [budgetnoMaster, setBudgetnoMaster] = useState<BudgetnoMaster[]>([]);
  const [performanceData, setPerformanceData] = useState<AccountBudgetCostPerformances>();

  const [table, setTable] = useState<tableDataType[]>();
  const [tableBack, setTableBack] = useState<tableDataType[][]>();
  const [disabledButton1, setDisabledButton1] = useState(true);
  const [disabledButton2, setDisabledButton2] = useState(false);
  // 初期値は当月
  const budgetMonth1 = moment().format("YYYYMM");
  const budgetMonth2 = moment().add(1, 'months').format("YYYYMM");
  const [budgetMonth, setBudgetMonth] = useState(yearMonth);
  // リンク表示用年月
  const dispMonth = moment().format("YYYY年M月");
  const dispNextMonth = moment().add(1, 'months').format("YYYY年M月");

  // 詳細画面のスタイル
  const useStyles = makeStyles((theme) => ({
    typography: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  }));
  const classesLocal = useStyles();

  // 予算枠番号マスター取得
  useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true,
      }
    });
    // 予算枠番号マスター取得
    const path = apollo_budgetno_master_path;
    ApolloAxios.get(path).then(response => {
      if (response.data.resultCode === 0) {
        const newBudgetNoMaster = mergeBudgetnoMaster(response.data.result);
        setBudgetnoMaster(newBudgetNoMaster.filter((m) => m.budgetNo !== 22));
      } else {
        console.log(response.data.message)
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_BUDGET_DETAIL,"E","0"),
            loading: false,
          }
        });
      }
    }).catch(err => {
			// 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_DETAIL,"E","0"), data, setmsg, history)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
    });
  }, []);
    
  // 広告主アカウント月額予算取得 (個別)
  useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true,
      }
    });
    // 広告主アカウント月額予算取得 (個別)
    const url = apollo_budget_path + "/" + accountid + "/" + budgetMonth1;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === 0) {
        setRow(response.data.result);
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false,
          }
        });
      } else {
        console.log(response.data.message);
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_BUDGET_DETAIL,"E","1"),
            loading: false
          }
        });
      }
    }).catch(err => {
			// 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_DETAIL,"E","1"), data, setmsg, history)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
    });
  }, []);

  // 広告主アカウント月額実績取得 (個別)
  useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true,
      }
    });
    // 広告主アカウント月額実績取得 (個別)
    const url = apollo_budget_cost_performances_path + "/" + accountid + "/" + budgetMonth1;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === 0) {
        setPerformanceData(response.data.result);
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false,
          }
        });
      } else {
        console.log(response.data.message);
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_BUDGET_DETAIL,"E","2"),
            loading: false
          }
        });
      }
    }).catch(err => {
			// 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_DETAIL,"E","2"), data, setmsg, history)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
    });
  }, []);
  
  // テーブル表示データ変更Effect
  useEffect(() => {
    createTableData();
  }, [row, budgetnoMaster, performanceData]);

  // 予算枠番号マスター情報にZeus配信種別のレコードを追加
  const mergeBudgetnoMaster = (budgetnoMaster: BudgetnoMaster[]) => {
    // Zeus配信種別別月額予算props引数
    const newBudgetnoMasterList = optionsZeusDeliveryType.map((v) => {
      var newBudgetnoMaster: BudgetnoMaster = {
        budgetNo : 1 * 10 + v.value,
        budgetName : v.label,
        budgetAmountFlg : 2,
        colorCode : "#FFFFFF",
        sort : v.value,
      }
      return newBudgetnoMaster;
    })
    const result = budgetnoMaster.concat(newBudgetnoMasterList);
    result.sort((a, b) => a.budgetNo - b.budgetNo);
    return result;
  }
  // テーブル表示データ作成
  const createTableData = () => {
    if (!(row && budgetnoMaster && performanceData)) return;
    // if (!(row && budgetnoMaster)) return;
    // 表示データ作成
    var tableData:tableDataType[][] = [];
    // for (var index in [budgetMonth1, budgetMonth2]) {
    [budgetMonth1, budgetMonth2].map((_, index) => {
      var tableData1:tableDataType[] = [];
      var costZues = 0;
      budgetnoMaster.map((budgetno:BudgetnoMaster) => {
        var cost = 0;
        // データ不正によりメニュー別実績が取れない場合があるためチェックする
        if (performanceData.budgetCostPerformance) {
          // Zeus配信種別実績を含まないようにする
          performanceData && performanceData.budgetCostPerformance.map((performance) => {
            if (performance.budgetNo === budgetno.budgetNo) {
              cost += performance.cost;
            }
            // Zeusの実績を集計する
            if (performance.budgetNo > 10 && performance.budgetNo < 20) {
              costZues += performance.cost;
            }
            return null;
          });
        }
        var tableDataWork = {
          budgetno: budgetno.budgetNo,
          budgetName: budgetno.budgetName,
          cost: cost,
          platformBudget1Amount: 0,
          platformBudget2Amount: 0,
          message: "",
        }
        if (row.amounts) {
          // 広告主アカウント月額予算データがある場合
          row.amounts.map((amount:AmountMessage) => {
            if (amount.budgetNo === budgetno.budgetNo) {
              var message = amount.message.substring(amount.message.indexOf("「"));
              if (index === 0) {
                tableDataWork.platformBudget1Amount = amount.budgetAmount;
                tableDataWork.platformBudget2Amount = amount.nextBudgetAmount;
                // 集計したZeusの実績をセットする
                if (amount.budgetNo === 10) {
                  tableDataWork.cost = costZues;
                } else {
                  tableDataWork.cost = cost;
                }
                tableDataWork.message = message;
              } else {
                tableDataWork.platformBudget1Amount = amount.nextBudgetAmount;
                tableDataWork.cost = 0;
                tableDataWork.message = message;
              }
            }
            return null;
          });
        }
        tableData1.push(tableDataWork);
        return null;
      });
      tableData.push(tableData1);
      return null;
    });
    // 表示データ保存
    setTableBack(tableData);
    // 翌月指定の時は、翌月設定する
    if (budgetMonth === budgetMonth1) {
      handleChange1();
      setTable(tableData[0])
    } else {
      handleChange2();
      setTable(tableData[1])
    }
  }

  // リストカラム定義
  const columns = [
    {
      name: "budgetName",
      label: "広告メニュー",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          // 配信種別データはインデントする
          if (table && (table[idx].budgetno === 11 || table[idx].budgetno === 12)) {
            return <Typography variant="inherit" noWrap style={{paddingLeft:"3em"}}>{table && table[idx].budgetName}</Typography>;
          }
          return <Typography variant="inherit" noWrap>{table && table[idx].budgetName}</Typography>;
        }
      }
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          // 予算データからプラットフォームID取得
          var platformAccountId = "";
          var menuId = 0;
          var workDisabled = false;
          var workButton = true;
          row && row.amounts && row.amounts.map((data) => {
            if (table && (table[idx].budgetno === 11 || table[idx].budgetno === 12)) {
              workButton = false;
            }
            if (data.budgetNo === (table ? table[idx].budgetno : 0)) {
              platformAccountId = data.platformAccountId;
              menuId = data.menuId;
            }
            return null;
          });
          if (menuId === 0) {
            workDisabled = true;
          }
          if (workButton) {
            return (
              <Button
                className={classes.buttonTop}
                variant={"contained"}
                color={"primary"}
                disabled={workDisabled}
                onClick={() => handleClickDetailOpen(menuId, platformAccountId)}>
                詳細
              </Button>
            );
          }
        }
      },
    },
    // 当月実績
    {
      name: "cost",
      label: "当月実績",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: number) => {
          return value? "￥" + Number(value).toLocaleString() : "￥" + 0;
        }
      }
    },
    {
      name: "platformBudget1Amount",
      label: "当月予算",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: number) => {
          return value? "￥" + Number(value).toLocaleString() : "￥" + 0;
        },
      },
    },
    {
      name: "platformBudget2Amount",
      label: "翌月予算",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return value? "￥" + Number(value).toLocaleString() : "￥" + 0;
        },
      },
    },
    {
      name: "message",
      label: "メッセージ",
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  // 詳細ボタンハンドラ
  const handleClickDetailOpen = (menuId: number, platformAccountId: string) => {
    var accountGroupId = row?.accountgroupId ? row.accountgroupId : 0;
    var accountGroupName = row?.accountgroupName ? row.accountgroupName : "";
    var accountId =  row?.accountId ? row.accountId : 0;
    var accountName = row?.accountName ? row.accountName : "";
    //コンテキストを更新
    dispatch({
      type: "changeAccount",
      payload: {
        ...state,
        current: {
          ...state.current,
          accountGroupId: accountGroupId,
          accountGroupName: accountGroupName,
          accountId: accountId,
          accountName: accountName,
        }
      }
    });
    // 各プラットフォーム詳細画面へ遷移
    const path = valueToOption(menuId + "", options_platformdetail_path);
    history.push(path.label + accountGroupId + "/" + accountId + "/" + platformAccountId + "?type=bu&month=" + budgetMonth)
    //history.push(budgets_path + "/" + accountid + "/" + budgetMonth1)
  }

  // 当月変更ハンドラ
  const handleChange1 = () => {
    setBudgetMonth(budgetMonth1);
    setDisabledButton1(true);
    setDisabledButton2(false);
    if (tableBack) {
      setTable(tableBack[0]);
    }
  };
  
  // 翌月変更ハンドラ
  const handleChange2 = () => {
    setBudgetMonth(budgetMonth2);
    setDisabledButton1(false);
    setDisabledButton2(true);
    if (tableBack) {
      setTable(tableBack[1]);
    }
  };
  // 戻るボタンハンドラ
  const handelGoback = () => {
    var backMonth = budgetMonth;
    if (!backMonth) backMonth = yearMonth;
    history.push(budgets_path + "/" + backMonth);
  }
  // データリスト表示オプション
  const options = {
      filter: false,
      download: false,
      print: false,
      search:false,
      sort: false,
      sortOrder: false,
      viewColumns:false,
      selectableRows: 'none',
      pagination:false,
      jumpToPage: false,
      expandableRows: false,
      expandableRowsHeader: false,
      expandableRowsOnClick: false,
  }

  // 画面表示
  return (
    <GenericTemplate title="">
      <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_OPERATOR}>
        <ApolloBreadcrumbs bread_no={72} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
                          platform={""}/>
        <Grid xs={12} spacing={0}>
          <Typography variant="button" display="block" align="right">
            {disabledButton1 ?
              <>
                <Button size="small"><span style={{borderBottom:"solid", borderColor:"red", borderWidth:"3px"}}>{dispMonth}</span></Button>
                <Box display="inline">|</Box>
                <Button color="primary" size="small" onClick={() => handleChange2()}><span style={{borderBottom:"solid", borderColor:"white", borderWidth:"3px"}}>{dispNextMonth}</span></Button>
              </>
              :
              <>
                <Button color="primary" size="small" onClick={() => handleChange1()}><span style={{borderBottom:"solid", borderColor:"white", borderWidth:"3px"}}>{dispMonth}</span></Button>
                <Box display="inline">|</Box>
                <Button size="small"><span style={{borderBottom:"solid", borderColor:"red", borderWidth:"3px"}}>{dispNextMonth}</span></Button>
              </>
            }
            {/* <Button className={classes.buttonTop} variant="contained" color="primary" onClick={()=>handleChange1()} disabled={disabledButton1}>
            {dispMonth}
            </Button>
            <Button className={classes.buttonTop} variant="contained" color="primary" onClick={()=>handleChange2()} disabled={disabledButton2}>
            {dispNextMonth}
            </Button> */}
          </Typography>
        </Grid>
        <Card className={classes.table} variant="outlined">
        <Typography className={classesLocal.typography} variant="button" display="block" align="left">
          <Grid xs={12} container>
            <Grid xs={12} md={3}>
              広告主アカウント
            </Grid>
            <Grid xs={12} md={9}>
              {row?.accountName}
            </Grid>
            <Grid xs={12} md={3}>
              アカウント月額予算
            </Grid>
            <Grid xs={12} md={9}>
              ￥
              {budgetMonth === budgetMonth1 ?
                row?.budgetAmount ? row.budgetAmount.toLocaleString() : 0
              :
                row?.nextBudgetAmount ? row.nextBudgetAmount.toLocaleString() : 0
              }
            </Grid>
          </Grid>
          </Typography>
        </Card>
        <Card className={classes.root} square variant="outlined">
          <ApolloDataTable
            title=""
            data={table}
            columns={columns}
            options={options}
          />
        </Card>
        <CardActions className={classes.cardaction}>
          <Button
            variant="contained"
            color="primary"
            onClick={handelGoback}
            className={classes.button}
          >
            戻る
          </Button>
        </CardActions>
      </ApolloUserProfileAuth>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

export default BudgetDetail;
